import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

/**
 * Simple data dialog component
 */
@Component({
  selector: 'app-simple-data-dialog',
  templateUrl: './simple-data-dialog.component.html',
  styleUrls: ['./simple-data-dialog.component.scss'],
})
export class SimpleDataDialogComponent implements OnInit {
  /**
   * Primary key
   */
  primaryKey: string;

  /**
   * Form
   */
  form: FormGroup;

  /**
   * Response
   */
  response: any;

  /**
   * Element source
   */
  elementSource: any;

  /**
   * Element source keys
   */
  elementSourceKeys: any;

  /**
   * Is updating source boolean
   */
  isUpdatingSource: boolean;

  /**
   * Constructor
   *
   * @param dialogRef MatDialogRef
   * @param data Data for dialog
   */
  constructor(public dialogRef: MatDialogRef<SimpleDataDialogComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any) {
    this.elementSource = this.data.elementSource;
    this.primaryKey = this.data.primaryKey;
    this.elementSourceKeys = Object.keys(this.elementSource);
    this.form = new FormGroup({});
  }

  /**
   * ngOnInit
   */
  ngOnInit(): void {
    const primaryKeysValue = this.elementSource[this.primaryKey];
    this.isUpdatingSource = primaryKeysValue !== null && primaryKeysValue !== '' && typeof primaryKeysValue !== 'undefined';

    for (const i of this.elementSourceKeys) {
      this.form.addControl(i, new FormControl(this.elementSource[i], Validators.required));
    }
  }

  /**
   * Save data dialog
   */
  save(): void {
    this.updateValuesFromSource();
    this.dialogRef.close({
      isUpdate: this.isUpdatingSource,
      elementSource: this.elementSource,
    });
  }

  /**
   * Close data dialog
   */
  close(): void {
    this.dialogRef.close();
  }

  /**
   * Update values from source
   */
  updateValuesFromSource(): void {
    for (const i in this.elementSourceKeys) {
      if (this.elementSourceKeys.hasOwnProperty(i)) {
        if (this.elementSource[this.elementSourceKeys[i]] === this.form.value[this.elementSourceKeys[i]] && this.isUpdatingSource) {
          delete this.elementSource[this.elementSourceKeys[i]];
        } else {
          this.elementSource[this.elementSourceKeys[i]] = this.form.value[this.elementSourceKeys[i]];
        }
      }
    }
  }
}
